export default __webpack_public_path__ + "static/media/notification-general.645efd17.svg";